var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { DialogClientService } from '../../../../services/basics/dialog-client.service';
import { DashboardClientService } from '../../../../services/dashboard/dashboard-client.service';
var ShareDashboardDialog = /** @class */ (function () {
    function ShareDashboardDialog(dialogClient, dashboardClientService) {
        this.dialogClient = dialogClient;
        this.dashboardClientService = dashboardClientService;
    }
    ShareDashboardDialog.prototype.cancel = function () {
        this.dialogClient.hide();
    };
    ShareDashboardDialog.prototype.share = function () {
        var _this = this;
        this.dashboardClientService.shareDashboard(this.dashboard.dashboardId, [this.userId]).then(function (response) {
            _this.dialogClient.hide();
        });
    };
    ShareDashboardDialog.prototype.activate = function (model) {
        if (model && model.dashboard) {
            this.dashboard = model.dashboard;
        }
    };
    ShareDashboardDialog = __decorate([
        transient(),
        autoinject(),
        __metadata("design:paramtypes", [DialogClientService, DashboardClientService])
    ], ShareDashboardDialog);
    return ShareDashboardDialog;
}());
export { ShareDashboardDialog };
